import type { ReactNode } from "react";

import { Redirect } from "react-router-dom";

import { useAuthContext } from "~/v2/providers/AuthProvider";

export const GuestOnly = ({ children }: { children: ReactNode }) => {
  const { authStatus, cognitoUser } = useAuthContext();

  if (authStatus === "loading") {
    return null;
  }

  const isAuthenticated = cognitoUser?.attributes?.email_verified === true;

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  return <>{children}</>;
};
